import React, { useState } from "react";

const SpinnerButton = (props) => {
    const [value, setValue] = useState(1);
    const isDisabled = props.disabled ?? false;

    return (
        <div className={props.className ?? ""} style={props.style ?? {}}>
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <button className="btn btn-outline-secondary" style={{borderRadius: '0px', borderRight: '1px solid #ccc'}} type="button" id="button-addon0" disabled={isDisabled} onClick={() => {
                        let previousValue = value;
                        let newValue = value - 1;
                        if(newValue === 0){
                            return;
                        }
                        setValue(newValue);
                        if(props.onChange){
                            props.onChange({previousValue: previousValue, value: newValue});
                        }
                    }}>-</button>
                </div>
                <input type="text" className="form-control text-center" placeholder="" disabled style={{borderTop: '1px solid #000', borderBottom: '1px solid #000', fontWeight: 'bold'}} value={value} />
                <div className="input-group-append">
                    <button className="btn btn-outline-secondary" style={{borderRadius: '0px', borderLeft: '1px solid #ccc'}} type="button" id="button-addon1" disabled={isDisabled} onClick={() => {
                        let previousValue = value;
                        let newValue = value + 1;
                        setValue(newValue);
                        if(props.onChange){
                            props.onChange({previousValue: previousValue, value: newValue});
                        }
                    }}>+</button>
                </div>
            </div>
        </div>
    );
}

export default SpinnerButton;